export default {
  header: 'Organization Admin',
  groupKey: 'admin',
  filters: [
    {
      text: 'View and edit Users',
      value: 'viewUsers',
    },
    {
      text: 'Add a new User',
      value: 'newUser',
    },
    {
      text: 'Edit Company Demographics',
      value: 'companyDemo',
    },
    {
      text: 'Update Supplier Profile',
      value: 'myCapabilities',
    },
    {
      text: 'Update Bid Match Settings',
      value: 'bidMatch',
    },
  ],
};



// WEBPACK FOOTER //
// ./src/config/searchFilters/AdminFilters.js